import { Usb, Monitor, Apple } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { plotters } from "@/lib/plotters";

export const Plotter = () => (
  <section className="relative overflow-hidden py-14 lg:py-20" data-testid="plotter-section">
    <div className="starfield opacity-50" aria-hidden />
    <div aria-hidden className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-blue/40 to-transparent" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="text-center" data-testid="plotter-brands">
        <p className="mono-label justify-center">Xpattern // Plotter compatibility</p>
        <h2 className="display mx-auto mt-5 max-w-4xl text-4xl text-white sm:text-5xl lg:text-7xl" data-testid="plotter-headline">
          Works with the plotter <br className="hidden sm:block" /><span className="text-cyan-glow">you already own.</span>
        </h2>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-2" data-testid="plotter-os">
          <span className="mono-pill"><Monitor size={12} className="text-blue-text" /> Windows</span>
          <span className="mono-pill"><Apple size={12} className="text-blue-text" /> Mac iOS</span>
        </div>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-2 sm:gap-2.5">
          {plotters.map((p) => (
            <span
              key={p.brand}
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-line bg-panel px-3.5 py-1.5 text-sm font-medium tracking-tight text-silver sm:px-4 sm:py-2 sm:text-[15px]"
              data-testid={`plotter-brand-${p.brand.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <Usb size={13} className="text-blue-text" /> {p.brand}
            </span>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
